export interface Representative {
  name: string;
  designation: string;
}

export interface UpdateSiteVisitFormValues {
  siteVisitFirstDate: string;
  siteVisitedByEntity: Representative[];
  siteVisitConfirmation: boolean;
  siteDeselect: false;
  siteVisitConfirmationRemarks?: string;
  siteDeselectReason?: string;
  attachments?: {
    documentUrl:
      | {
          id?: string;
          fileUrl?: string;
        }
      | string;
    type: string;
    key?: string;
  }[];
}

export const defaultUpdateSiteVisitValues: UpdateSiteVisitFormValues = {
  siteVisitFirstDate: "",
  siteVisitedByEntity: [{ name: "", designation: "" }],
  siteVisitConfirmation: false,
  siteDeselect: false,
  siteVisitConfirmationRemarks: "",
  siteDeselectReason: "",
  attachments: [],
};
